import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePortalSession } from '../../hooks/usePortalSession';

export function RequireService({ name, children }) {
  const { hasService } = usePortalSession();
  if (!hasService(name)) {
    return <Navigate to="/services" replace />;
  }
  return children;
}
